import React, {useEffect, useState} from 'react'
import {ArrowDownOnSquareIcon, EyeIcon, EyeSlashIcon, XMarkIcon} from "@heroicons/react/24/solid";
import SelectColorTypeDetails from "../../../design/components/design-editor/settings/select-color-type-details";
import _ from "lodash";
import Promise from "bluebird";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner"
import RenderFields from "../../../common/ui/render-fields";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {
    DEFAULT_MULTI_VARIANT_DESIGNER_TAB, DESIGN_KEY_PREFIX, DOWNLOAD_MULTI_IMAGE_TIME_DELAY, FLIP_DIRECTION_KEY,
    MULTI_VARIANT_DESIGNER_TABS_LIST, REPEAT_IMAGE_FIELD_LIST
} from "../../constants/design.constant";
import ShowDesignDetail from "../common/show-design-detail";
import {searchThemes} from "../../../theme/services/theme-data-service";
import {searchTags} from "../../../common/services/tag-data-service";
import SelectMultipleImages from "./select-multiple-images";
import {getNextItemKey} from "../../../common/utils/item-key-util";
import {firebaseStorage, storageRef} from "../../../firebase/client-app";
import {getDownloadURL} from "@firebase/storage";
import {getImageDownloadUrl, setImageSize} from "../../../common/utils/image-util";
import ViewSingleVariantDesign from "./view-single-variant-design";
import EditFlipDetails from "../design-editor/settings/edit-flip-details";
import {prepareImagePosition} from "../../utils/multi-variant-designer-util";
import {DOWNLOAD_IMAGE_TIME_DELAY} from "../../../shopify/constants/shopify.constant";
import {
    prepareDesignVariantLabel,
    prepareImageFileName, processApplyTemplateStyle,
    processDesignVariantDetail, processImagesLayer, processTextItemsLayer
} from "../../utils/design-variant-util";
import {processDesignVariantStatistics} from "../../utils/design-util";
import {addSingleDesignVariant, getSingleDesignVariant} from "../../services/design-variant-data-service";
import {updateSingleDesign} from "../../services/design-data-service";

const defaultSettings: any = {
    batchKey: 1,
    images: [],
    designVariants: [],
    background: {
        backgroundColor: "#D1D5DB",
        backgroundColorCodeKey: "300",
        backgroundColorKey: "gray",
        colorType: "solid"
    },
    noText: true,
    isRepeatImage: false,
    isBackgroundImage: true,
    size: 100,
    fillPatternOffsetXPercentage: 0,
    fillPatternOffsetYPercentage: 0,
    fillPatternRotation: 0,
    fillPatternRepeat: 'no-repeat'
}

const tabsList = MULTI_VARIANT_DESIGNER_TABS_LIST;

const MultiVariantDesigner = ({
                                  designDetail,
                                  setDesignDetail,
                                  parentProduct,
                                  quoteDetail,
                                  allTags,
                                  isLightButton = true
                              }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_MULTI_VARIANT_DESIGNER_TAB);
    const [commonSettings, setCommonSettings] = useState(null);
    const [imageIdsList, setImageIdsList] = useState(null);
    const [showGrid, setShowGrid] = useState(true);
    const [selectedImage, setSelectedImage] = useState(null);
    const [saveInProgress, setSaveInProgress] = useState(false);

    // const [allThemes, setAllThemes] = useState(null);

    const [downloadAllImages, setDownloadAllImages] = useState(false);

    useEffect(() => {
        if (showModal) {
            initCommonSettings();
            // getThemesList();
        }
    }, [showModal]);

    const initCommonSettings = () => {
        setImageIdsList([]);
        const initialCommonSettings = defaultSettings;
        initialCommonSettings.width = parentProduct.widthPixel;
        initialCommonSettings.height = parentProduct.heightPixel;
        initialCommonSettings.batchKey = getNextItemKey(designDetail?.batches, DESIGN_KEY_PREFIX.BATCH);

        setCommonSettings(initialCommonSettings);
    }

    /*const getThemesList = async () => {
        const themesListResult = await searchThemes('')
        setAllThemes(themesListResult);
    }*/

    const handleCloseAction = () => {
        setDownloadAllImages(false);
        setShowModal(false);
    }

    const handleSettingsChanges = (event?) => {
        const {name, value, type} = event.target;
        const existingCommonSettings = {...commonSettings};

        if (type === 'number') {
            existingCommonSettings[name] = _.parseInt(value);
        } else if (type === 'checkbox') {
            existingCommonSettings[name] = !existingCommonSettings[name];
        } else {
            existingCommonSettings[name] = value;
        }

        if (name === 'isRepeatImage') {
            existingCommonSettings.fillPatternRepeat = existingCommonSettings[name] ? 'repeat' : 'no-repeat';
        }

        processSettingsAttributes(existingCommonSettings);
        applySettingsToImages(existingCommonSettings);

        // console.log({existingCommonSettings})
        setCommonSettings(existingCommonSettings);
    }

    const processSettingsAttributes = (existingCommonSettings) => {
        if (_.isNaN(existingCommonSettings?.size)) {
            existingCommonSettings.size = 100;
        }

        if (_.isNaN(existingCommonSettings?.fillPatternOffsetXPercentage)) {
            existingCommonSettings.fillPatternOffsetXPercentage = 0;
        }

        if (_.isNaN(existingCommonSettings?.fillPatternOffsetYPercentage)) {
            existingCommonSettings.fillPatternOffsetYPercentage = 0;
        }

        if (_.isNaN(existingCommonSettings?.fillPatternRotation)) {
            existingCommonSettings.fillPatternRotation = 0;
        }
    }

    const applySettingsToImages = (existingCommonSettings) => {
        const existingImagesList = existingCommonSettings.images;

        _.forEach(existingImagesList, imageItem => {
            applySettingsToSingleImage(imageItem, existingCommonSettings);
        });

        existingCommonSettings.images = existingImagesList;
    }

    const applySettingsToSingleImage = (imageItem, settings) => {
        imageItem.width = imageItem.imageWidth * settings.size / 100;
        imageItem.height = imageItem.imageHeight * settings.size / 100;

        imageItem.fillPatternOffsetX = -imageItem.width * settings.fillPatternOffsetXPercentage / 100;
        imageItem.fillPatternOffsetY = imageItem.height * settings.fillPatternOffsetYPercentage / 100;

        imageItem.fillPatternScaleX = imageItem?.height / settings?.height;
        imageItem.fillPatternScaleY = imageItem?.height / settings?.height;

        imageItem.fillPatternRotation = settings.fillPatternRotation;
        imageItem.fillPatternRepeat = settings.fillPatternRepeat;

        imageItem.isRepeatImage = settings.isRepeatImage;
        imageItem.isBackgroundImage = settings.isBackgroundImage;
        imageItem.size = settings.size;
        imageItem.fillPatternOffsetXPercentage = settings.fillPatternOffsetXPercentage;
        imageItem.fillPatternOffsetYPercentage = settings.fillPatternOffsetYPercentage;
    }

    const prepareSelectedImagesForVariant = async (addedImages) => {
        const existingCommonSettings = {...commonSettings};
        const existingImagesList = existingCommonSettings?.images || [];
        const existingImageIdsList = imageIdsList || [];

        processSettingsAttributes(existingCommonSettings);

        await Promise.mapSeries(addedImages, async addedImage => {
            if (existingImageIdsList.indexOf(addedImage?.id) === -1) {
                existingImageIdsList.push(addedImage?.id);
                setImageIdsList(existingImageIdsList);

                const imageDetail = await processAddedImageShape(addedImage, existingImagesList);

                if (imageDetail) {
                    applySettingsToSingleImage(imageDetail, existingCommonSettings);
                    existingCommonSettings.images.push(imageDetail);
                    prepareDesignVariant(imageDetail, existingCommonSettings);
                }
            }
        });

        setCommonSettings(existingCommonSettings);
    }

    const prepareDesignVariant = (imageDetail, existingCommonSettings) => {
        const existingVariants = existingCommonSettings?.designVariants || [];

        const designVariant: any = {};
        designVariant.designId = designDetail?.id;
        designVariant.name = designDetail?.name;
        designVariant.key = getNextItemKey(designDetail?.variants || existingVariants, DESIGN_KEY_PREFIX.VARIANT);
        designVariant.status = 'in-design';
        designVariant.batchKey = existingCommonSettings.batchKey;
        prepareImageFileName(designVariant, designDetail);

        designVariant.images = [];
        delete imageDetail.key;
        designVariant.images.push(imageDetail);

        existingVariants.push(designVariant);
        existingCommonSettings.designVariants = existingVariants;
    }

    const processAddedImageShape = async (addedImage, existingImages) => {
        let imageDetail;
        await getImageDownloadUrl(addedImage);

        if (addedImage?.downloadUrl) {
            if (!addedImage.height || !addedImage.width) {
                await setImageSize(addedImage);
            }

            imageDetail = {
                key: getNextItemKey(existingImages, DESIGN_KEY_PREFIX.IMAGE),
                x: 0,
                y: 0,
                width: addedImage.width,
                height: addedImage.height,
                imageWidth: addedImage.width,
                imageHeight: addedImage.height,
                id: addedImage?.id,
                src: addedImage?.downloadUrl,
                url: addedImage?.downloadUrl,
                fileUrl: addedImage?.fileUrl,
                displayLabel: addedImage?.displayLabel,
                thumbnail: addedImage?.thumbnail,
            }

            // existingImages.push(imageDetail);
        }

        return imageDetail;
    }

    const toggleShowGrid = (e) => {
        setShowGrid(!showGrid);
    }

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {
                if (showModal && downloadAllImages) {
                    let nextIndex = 0;
                    let existingCommonSettings = {...commonSettings};
                    let currentSelectedImage: any = {...selectedImage};

                    if (currentSelectedImage) {
                        const currentIndex = _.findIndex(existingCommonSettings?.images, ['id', currentSelectedImage?.id]);
                        nextIndex = currentIndex + 1;
                    }

                    if (existingCommonSettings && existingCommonSettings?.images?.hasOwnProperty(nextIndex)) {
                        setSelectedImage(existingCommonSettings?.images[nextIndex]);
                    } else {
                        setDownloadAllImages(false);
                        setSelectedImage(null);
                    }
                }

            }, DOWNLOAD_MULTI_IMAGE_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    });

    const saveAllDesignVariants = async () => {
        setSaveInProgress(true);
        const existingDesignDetail = {...designDetail};
        const existingVariants = existingDesignDetail.variants || [];

        await Promise.mapSeries(commonSettings.designVariants, async newDesignVariant => {
            await addNewDesignVariant(newDesignVariant, existingDesignDetail, existingVariants);
        });

        existingDesignDetail.variants = existingVariants;
        prepareDesignBatch(existingDesignDetail);
        processDesignVariantStatistics(existingDesignDetail);
        setDesignDetail(existingDesignDetail);
        await updateSingleDesign(existingDesignDetail);

        setSaveInProgress(false);
        // setShowModal(false);
    }

    const prepareDesignBatch = (existingDesignDetail) => {
        const existingCommonSettings = {...commonSettings};
        const designBatch: any = {
            batchKey: existingCommonSettings.batchKey,
            background: existingCommonSettings.background,
            noText: existingCommonSettings.noText,
            isRepeatImage: existingCommonSettings.isRepeatImage,
            isBackgroundImage: existingCommonSettings.isBackgroundImage,
            size: existingCommonSettings.size,
            fillPatternOffsetXPercentage: existingCommonSettings.fillPatternOffsetXPercentage,
            fillPatternOffsetYPercentage: existingCommonSettings.fillPatternOffsetYPercentage,
            fillPatternRotation: existingCommonSettings.fillPatternRotation,
            fillPatternRepeat: existingCommonSettings.fillPatternRepeat,
        }

        const existingBatches = existingDesignDetail?.batches || [];
        existingBatches.push(designBatch);
        existingDesignDetail.batches = existingBatches;
    }

    const addNewDesignVariant = async (newDesignVariant, existingDesignDetail, existingVariants) => {
        const newVariant: any = {};
        newDesignVariant.key = getNextItemKey(existingVariants, DESIGN_KEY_PREFIX.VARIANT);

        newVariant.designId = newDesignVariant.designId;
        newVariant.name = newDesignVariant.name;
        newVariant.key = newDesignVariant.key;
        newVariant.status = newDesignVariant.status;
        newVariant.batchKey = newDesignVariant.batchKey;

        processDesignVariantDetail(newDesignVariant, designDetail, quoteDetail, parentProduct);
        newDesignVariant.settings.background = commonSettings?.background;
        newDesignVariant.settings.noText = true;

        processTextItemsLayer(newDesignVariant);
        processImagesLayer(newDesignVariant);

        const addedVariant: any = await addSingleDesignVariant(newDesignVariant);
        newVariant.id = addedVariant.id;
        existingVariants.push(newVariant);
    }

    return (
        <>
            {parentProduct &&
                <div className="flex items-center justify-center">
                    <button
                        className={`py-2 px-4 ${isLightButton ? 'button-outline-gray' : 'button-gray'}`}
                        onClick={() => setShowModal(true)}>
                        <span>Design Multiple Variants</span>
                    </button>
                </div>
            }

            {showModal ? (
                <>
                    <div
                        className="w-full h-full justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-full h-full">
                            {/*content*/}
                            <div
                                className="border-0 shadow-lg relative flex flex-col w-full h-full bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex justify-between px-5 pt-4 rounded-t">
                                    <div className='flex justify-start items-center w-1/5'>
                                        <h3 className="text-2xl font-bold ml-2">Multi Variant Designer</h3>
                                    </div>

                                    <div className="w-4/5 flex justify-start">
                                        <div>
                                            <ShowDesignDetail designDetail={designDetail}/>
                                        </div>

                                        <div className="ml-2 flex justify-start items-center">
                                            {commonSettings?.designVariants?.length > 0 &&
                                                <>

                                                    <div className="mx-2">
                                                        <button onClick={toggleShowGrid}
                                                                className="rounded flex items-center justify-center border bg-gray-100 text-gray-500 border-gray-500 hover:text-gray-700 hover:bg-white hover:border-gray-500 ml-2">
                                                            {showGrid &&
                                                                <div className="p-2">
                                                                    <EyeIcon className="h-6 w-6"/>
                                                                </div>
                                                            }

                                                            {!showGrid &&
                                                                <div className="p-2">
                                                                    <EyeSlashIcon className="h-6 w-6"/>
                                                                </div>
                                                            }
                                                        </button>
                                                    </div>

                                                    <div>
                                                        <button onClick={() => {
                                                            setDownloadAllImages(true);
                                                        }}
                                                                className="button-gray py-2 px-3 flex justify-center">
                                                            <div className="pr-2">
                                                                <ArrowDownOnSquareIcon className="h-6 w-6"/>
                                                            </div>
                                                            Download All
                                                        </button>
                                                    </div>

                                                    <div className={"mx-2"}>
                                                        <button onClick={saveAllDesignVariants}
                                                                className="button-green py-2 px-3 flex justify-center">
                                                            Save Design Variants
                                                        </button>
                                                    </div>

                                                    <div className="mx-2">
                                                        <ShowProgressSpinner
                                                            dataFetchInProgress={downloadAllImages || saveInProgress}/>
                                                    </div>

                                                </>
                                            }
                                        </div>
                                    </div>

                                    <div className="mr-2 flex justify-center items-center">
                                        <div className="">
                                            <button
                                                className="button-gray-outline px-3 py-2"
                                                onClick={handleCloseAction}>
                                                <div className="">
                                                    <XMarkIcon className="h-6 w-6"/>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {/*body*/}
                                <div
                                    className="relative px-6">

                                    <div className="flex justify-center mt-6">

                                        <div className="flex flex-wrap justify-start w-3/4">


                                            <div
                                                className="multi-variant-designer-container overflow-y-scroll w-full border border-gray-300 rounded-b bg-gray-100 flex flex-wrap content-start items-start justify-start">

                                                {/*{commonSettings?.images?.map((imageDetail, index) => (
                                                    <React.Fragment key={index}>

                                                        <ViewSingleVariantDesign
                                                            settings={commonSettings}
                                                            selectedImageDetail={selectedImage}
                                                            imageDetail={imageDetail}
                                                            variantIndex={index + 1}
                                                            showGrid={showGrid}
                                                        />

                                                    </React.Fragment>
                                                ))}*/}

                                                {commonSettings?.designVariants?.map((designVariant, index) => (
                                                    <React.Fragment key={index}>

                                                        <ViewSingleVariantDesign
                                                            designVariant={designVariant}
                                                            settings={commonSettings}
                                                            selectedImageDetail={selectedImage}
                                                            imageDetail={designVariant?.images[0]}
                                                            variantIndex={index + 1}
                                                            showGrid={showGrid}
                                                        />

                                                    </React.Fragment>
                                                ))}

                                            </div>

                                        </div>

                                        <div
                                            className="w-1/4 px-4 rounded ml-4">

                                            <div className="">
                                                <ShowTabsList
                                                    setSelectedTab={setSelectedTab}
                                                    selectedTab={selectedTab}
                                                    tabsList={tabsList}/>
                                            </div>

                                            <div
                                                className="multi-variant-designer-settings-container overflow-y-scroll border-x border-b border-gray-500 bg-gray-100 p-4">

                                                {commonSettings?.width > 0 && selectedTab?.key === 'settings' &&
                                                    <>
                                                        <SelectColorTypeDetails
                                                            label={'Background Color & Shade'}
                                                            parentForm={commonSettings?.background}
                                                            colorAttribute={'background'}
                                                            colorKeyAttribute={'backgroundColorKey'}
                                                            colorCodeKeyAttribute={'backgroundColorCodeKey'}
                                                            settings={commonSettings}
                                                            handleColorDetailsChanges={handleSettingsChanges}
                                                            handleClearColorDetailsChanges={undefined}/>

                                                        <div className="mt-4 ml-2 text-lg text-purple-600">
                                                            Image Attributes
                                                        </div>

                                                        <div className="flex justify-between">

                                                            <div className="justify-start flex ml-2 mt-4 w-1/2">
                                                                <input
                                                                    type="checkbox"
                                                                    className="h-6 w-6 mr-1"
                                                                    id="isRepeatImage"
                                                                    name="isRepeatImage"
                                                                    value={commonSettings?.isRepeatImage}
                                                                    checked={commonSettings?.isRepeatImage}
                                                                    onChange={handleSettingsChanges}>
                                                                </input>
                                                                <div className='ml-2'>
                                                                    <label className='field-label self-center'
                                                                           htmlFor='isRepeatImage'>Repeat Image</label>
                                                                </div>
                                                            </div>

                                                            {/*<div className="w-1/2">
                                                                <RenderFields
                                                                    parentForm={commonSettings}
                                                                    handleDetailChanges={handleImageDetailChanges}
                                                                    fieldList={LOGO_FIELD_LIST}
                                                                    enableEdit={true}
                                                                    fieldClassName={'w-1/2'}/>
                                                            </div>*/}

                                                            {/*<div className="w-1/2">
                                                                <EditFlipDetails
                                                                    item={commonSettings}
                                                                    handleFlipDetailsChanges={handleImageDetailChanges}/>
                                                            </div>*/}

                                                        </div>

                                                        <div className="flex flex-wrap justify-start">
                                                            <RenderFields
                                                                parentForm={commonSettings}
                                                                handleDetailChanges={handleSettingsChanges}
                                                                fieldList={_.groupBy(REPEAT_IMAGE_FIELD_LIST, 'group')['dimension']}
                                                                enableEdit={true}
                                                                fieldClassName={'w-1/2'}/>
                                                        </div>
                                                    </>
                                                }

                                                {commonSettings?.width > 0 && selectedTab?.key === 'images' &&
                                                    <>
                                                        <div
                                                            className="multi-variant-designer-settings-container">

                                                            <SelectMultipleImages
                                                                allTags={allTags}
                                                                addImageList={prepareSelectedImagesForVariant}
                                                            />

                                                        </div>
                                                    </>
                                                }

                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    )
}

export default MultiVariantDesigner
